import { useCallback, useEffect, useState } from 'react';

const PREFIX = 'innobic.bo.';

/**
 * state ที่จำค่าไว้ต่อผู้ใช้ต่อเครื่อง — ใช้กับความหนาแน่นของแถว ความกว้าง SplitView
 * ชุดคอลัมน์ที่เลือก และชุดตัวกรองที่บันทึกไว้
 *
 * ข้อกำหนด: ห้ามล้าง key อื่นใน localStorage และต้องทนกรณี storage ถูกปิด (โหมดส่วนตัว)
 */
export function usePersistentState<T>(key: string, initial: T): [T, (next: T | ((prev: T) => T)) => void] {
  const storageKey = PREFIX + key;

  const [value, setValue] = useState<T>(() => {
    try {
      const raw = window.localStorage.getItem(storageKey);
      return raw === null ? initial : (JSON.parse(raw) as T);
    } catch {
      return initial;
    }
  });

  useEffect(() => {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(value));
    } catch {
      /* storage ถูกปิด — ทำงานต่อได้โดยไม่จำค่า */
    }
  }, [storageKey, value]);

  const set = useCallback((next: T | ((prev: T) => T)) => {
    setValue((prev) => (typeof next === 'function' ? (next as (p: T) => T)(prev) : next));
  }, []);

  return [value, set];
}

export const useTableDensity = () => usePersistentState<'compact' | 'normal' | 'comfortable'>('density', 'normal');
